module.exports = __webpack_public_path__ + "img/lineamientos.d8e61b6d.jpg";